module.exports = __webpack_public_path__ + "static/layer2-fc973328cd5420e3ad71a93c27f9edf2.png";